<template>
  <div v-if="isAnyModalOpen">
    <applied-rules-review
      v-if="appliedRulesReview.visible"
      :visible.sync="appliedRulesReview.visible"
      :suggestions="appliedRulesReview.suggestions"
    />
    <attached-view
      :visible.sync="attachedView.visible"
      :associate_id="attachedView.associate_id"
      :initial-document="attachedView.initial_document"
      :request_id="attachedView.request_id"
      @update="attachedView.onUpdate"
      @renew="attachedView.onRenew"
    />
    <associate-profile-view
      :visible.sync="profile.visible"
      :associate_number.sync="profile.associate_number"
      :open-tab="profile.open_tab"
      :is-editing.sync="profile.is_editing"
      :project_id="profile.project_id"
      @edit="profile.edit"
    />
    <sequence-review
      :visible.sync="sequenceReview.visible"
      :associate="sequenceReview.associate"
      :sequence_id="sequenceReview.sequence_id"
      :is_valid_id="sequenceReview.is_valid_id"
      @save="sequenceReview.onSave"
    />
    <document-view
      :visible.sync="documentView.visible"
      :document_id="documentView.document_id"
      :associate_id="documentView.associate_id"
      :version="documentView.version"
    />
    <document-form
      :visible.sync="documentCreate.visible"
      :document_id.sync="documentCreate.document_id"
      :version_number.sync="documentCreate.version_number"
      :initial_values="documentCreate.initial_values"
      @edit="documentCreate.edit"
    />
    <assignment-request-review
      :visible.sync="assignmentRequestReview.visible"
      :request-id="assignmentRequestReview.requestId"
      @reviewed="assignmentRequestReview.onReviewed"
    />
    <attached-form
      :visible.sync="attachedCreate.visible"
      :template="attachedCreate.template"
      @save="attachedCreate.save"
    />
    <backfill-create
      :visible.sync="backfillCreate.visible"
      :target-object="backfillCreate.targetObject"
      :type="backfillCreate.type"
      :specific-associates="backfillCreate.specificAssociates"
      @add="backfillCreate.add"
    />
    <join-modal
      :visible.sync="joinProject.visible"
      :alert.sync="joinProject.alert"
      @save="joinProject.save"
      @change="joinProject.change"
    />
    <dynamic-form-modal
      :visible.sync="dynamicForm.visible"
      :type="dynamicForm.type"
      :initial-value="dynamicForm.initialValue"
      @save="dynamicForm.save"
    />
    <legal-entity-modal
      :visible.sync="legalEntity.visible"
      :editing-agency.sync="legalEntity.editingAgency"
      :show-create-associate="legalEntity.showCreateAssociate"
      :initial-values="legalEntity.initialValues"
      @add="legalEntity.add"
    />
    <time-off-view
      :visible.sync="timeOff.visible"
      :timeOffId.sync="timeOff.timeOffId"
      :timeOffList="timeOff.timeOffList"
      @update="timeOff.update"
    />
    <shift-view
      :visible.sync="shiftView.visible"
      :shifts-list="shiftView.shifts_list"
      :shift_id.sync="shiftView.shift_id"
      :open_tab.sync="shiftView.open_tab"
      @edit="shiftView.edit"
    />
    <notification-modal
      :visible.sync="notification.visible"
      :associate_number.sync="notification.associate_number"
      :notification="notification.notification"
      @edit="notification.edit"
    />
    <payment-modal :payment-id.sync="payment.id" @change="payment.edit" />
    <request-payment-modal
      :visible.sync="requestPayment.visible"
      :initial-payment-id="requestPayment.initialPaymentId"
      :initial-step="requestPayment.initialStep"
      @completed="requestPayment.onCompleted"
    />
    <final-paycheck-modal
      v-if="finalPaycheck.visible"
      :visible.sync="finalPaycheck.visible"
      :process-id="finalPaycheck.processId"
      @completed="finalPaycheck.onCompleted"
    />
    <table-export-modal
      :visible.sync="tableExport.visible"
      :columns="tableExport.columns"
      :export-entity="tableExport.exportEntity"
      @export="tableExport.export"
    />
    <delete-modal
      :visible.sync="deletion.visible"
      :title="deletion.title"
      :description="deletion.description"
      :action="deletion.action"
      :confirm-text="deletion.confirmText"
      :confirmation-value="deletion.confirmationValue"
      :input-placeholder="deletion.inputPlaceholder"
      :helper-text="deletion.helperText"
      :confirm-button-text="deletion.confirmButtonText"
      :on-confirm="deletion.onConfirm"
    />
  </div>
</template>

<script>
import AttachedView from '@/modules/document/components/attached/attached-view.vue'
import DocumentView from '@/modules/document/components/document-view.vue'
import DocumentForm from '@/modules/document/components/document-form.vue'
import ProfileAssociateView from '@/modules/profile/components/profile-view.vue'
import SequenceReview from '@/modules/sequence/components/review/sequence-review.vue'
import AttachedForm from '@/modules/document/components/attached/attached-form.vue'
import { createNamespacedHelpers } from 'vuex'
import CompleteRequestBackfill from '@/modules/complete-request/components/complete-request-backfill.vue'
import JoinProjectModal from '@/modules/project/components/join-project-modal.vue'
import DocumentDynamicView from '@/modules/document/components/document-dynamic-view.vue'
import legalEntityModal from '../modules/legal-entity/components/legal-entity-modal.vue'
import TimeOffView from '@/modules/time-off/components/view/time-off-view.vue'
import ShiftViewModal from '@/modules/shifts/components/modal/shift-view-modal.vue'
import NotificationSendModal from '@/modules/notifications/components/notification-send-modal.vue'
import PaymentInfo from '@/modules/payment/components/info/payment-info.vue'
import RequestPaymentModal from '@/modules/payment/components/request-payment/request-payment-modal.vue'
import TableExportModal from './entities/table/table-export-modal.vue'
import ModalDelete from './entities/modal/modal-delete.vue'
import ProfileAppliedRulesReview from '@/modules/profile/components/profile-applied-rules-review.vue'
import AssignmentRequestReview from '@/modules/user/components/assignment-requests/assignment-request-review.vue'
import FinalPaycheckModal from '@/modules/payment/components/final-paycheck/final-paycheck-modal.vue'

const { mapState: modalsState } = createNamespacedHelpers('modals')

export default {
  components: {
    'applied-rules-review': ProfileAppliedRulesReview,
    'associate-profile-view': ProfileAssociateView,
    'sequence-review': SequenceReview,
    'attached-view': AttachedView,
    'attached-form': AttachedForm,
    'document-view': DocumentView,
    'document-form': DocumentForm,
    'assignment-request-review': AssignmentRequestReview,
    'backfill-create': CompleteRequestBackfill,
    'join-modal': JoinProjectModal,
    'dynamic-form-modal': DocumentDynamicView,
    'legal-entity-modal': legalEntityModal,
    'time-off-view': TimeOffView,
    'shift-view': ShiftViewModal,
    'notification-modal': NotificationSendModal,
    'payment-modal': PaymentInfo,
    'request-payment-modal': RequestPaymentModal,
    'final-paycheck-modal': FinalPaycheckModal,
    'table-export-modal': TableExportModal,
    'delete-modal': ModalDelete
  },
  data() {
    return {}
  },
  computed: {
    ...modalsState({
      appliedRulesReview: state => state.modals.appliedRulesReview,
      profile: state => state.modals.profile,
      sequenceReview: state => state.modals.sequenceReview,
      attachedView: state => state.modals.attachedView,
      attachedCreate: state => state.modals.attachedCreate,
      documentView: state => state.modals.documentView,
      documentCreate: state => state.modals.documentCreate,
      assignmentRequestReview: state => state.modals.assignmentRequestReview,
      backfillCreate: state => state.modals.backfill,
      joinProject: state => state.modals.joinProject,
      dynamicForm: state => state.modals.dynamicForm,
      legalEntity: state => state.modals.legalEntity,
      timeOff: state => state.modals.timeOff,
      shiftView: state => state.modals.shiftView,
      notification: state => state.modals.notification,
      payment: state => state.modals.payment,
      requestPayment: state => state.modals.requestPayment,
      finalPaycheck: state => state.modals.finalPaycheck,
      tableExport: state => state.modals.tableExport,
      deletion: state => state.modals.deletion
    }),

    isAnyModalOpen() {
      return [
        this.appliedRulesReview.visible,
        this.attachedView.visible,
        this.profile.visible,
        this.sequenceReview.visible,
        this.documentView.visible,
        this.documentCreate.visible,
        this.assignmentRequestReview.visible,
        this.attachedCreate.visible,
        this.backfillCreate.visible,
        this.joinProject.visible,
        this.dynamicForm.visible,
        this.legalEntity.visible,
        this.timeOff.visible,
        this.shiftView.visible,
        this.notification.visible,
        this.payment.visible,
        this.requestPayment.visible,
        this.finalPaycheck.visible,
        this.tableExport.visible,
        this.deletion.visible
      ].some(visible => visible)
    }
  }
}
</script>
